import {Component, OnInit} from '@angular/core';
import {ToastrService, GlobalConfig} from 'ngx-toastr';
import {Station} from "../../../models/Station";
import {Telephone} from "../../../models/telephone";
import {StationService} from "../../../services/station.service";
import {HeaderService} from "../../../services/header/header.service";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-profile-entreprise',
    templateUrl: './profile-entreprise.component.html',
    styleUrls: ['./profile-entreprise.component.scss'],

})
export class ProfileEntrepriseComponent implements OnInit {
    logoPreview: string | null = null;
    file_url = environment.url_images;


    private options: GlobalConfig;
    currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

    clientId = this.currentUser?.id;
    stationId = this.currentUser?.stations?.[0]?.id;

    constructor(private toastr: ToastrService, private stationService: StationService, private headerService: HeaderService) {
        this.options = this.toastr.toastrConfig;
    }

    data: any = {
        id: 0,
        client_id: 0,
        station_id: 0,
        logo: '',
        label: '',
        nom_entreprise: '',
        matricule_fiscale: '',
        site_web: '',
        prenom: '',
        nom: '',
        email: '',
        adresses: [{
            id: 0,
            pays: '',
            region: '',
            code_postal: '',
            adresse: '',
            station_id: 0
        }],
        telephones: [],
        tel : ''
    };

    dataError: {
        logo: string;
        label: string;
        nom_entreprise: string;
        adresses: {
            region: string;
            code_postal: string;
            adresse: string;
        }[];
        telephones: string[]; // for numero errors
        telephoneTypes: string[]; // NEW: for type errors
    } = {
        logo: '',
        label: '',
        nom_entreprise: '',
        adresses: [{region: '', code_postal: '', adresse: ''}],
        telephones: [],
        telephoneTypes: [], // Initialize new array
    };

    ngOnInit(): void {
        this.headerService.setConfig({
            title: 'Profil de l\'entreprise',
            buttons: []
        });
        if (this.data.telephones.length === 0) {
            this.addTel();
        }

        this.stationService.getStation(this.stationId).subscribe({
            next: (res) => {
                console.log('🔍 [ProfileEntreprise] Réponse complète de l\'API GET:', res);
                console.log('🔍 [ProfileEntreprise] Station récupérée:', res.station);
                if (res.success && res.station) {
                    this.data = res.station;
                    // S'assurer que nom_entreprise est défini (utiliser nom_entreprise ou label comme fallback)
                    if (!this.data.nom_entreprise && this.data.label) {
                        this.data.nom_entreprise = this.data.label;
                    }
                    console.log('🔍 [ProfileEntreprise] Données assignées à this.data:', this.data);
                    console.log('🔍 [ProfileEntreprise] Propriétés disponibles:', Object.keys(this.data));
                    
                    // Vérifier si prenom, nom, email sont dans coordonnees ou directement dans station
                    if (this.data.coordonnees && Array.isArray(this.data.coordonnees) && this.data.coordonnees.length > 0) {
                        const coordonnee = this.data.coordonnees[0];
                        console.log('🔍 [ProfileEntreprise] Coordonnées trouvées:', coordonnee);
                        this.data.prenom = coordonnee.prenom || '';
                        this.data.nom = coordonnee.nom || '';
                        this.data.email = coordonnee.email || '';
                    } else if (this.data.coordonnees && !Array.isArray(this.data.coordonnees)) {
                        // Si coordonnees est un objet unique
                        console.log('🔍 [ProfileEntreprise] Coordonnées (objet unique):', this.data.coordonnees);
                        this.data.prenom = this.data.coordonnees.prenom || '';
                        this.data.nom = this.data.coordonnees.nom || '';
                        this.data.email = this.data.coordonnees.email || '';
                    } else {
                        // Si les champs sont directement dans station
                        console.log('🔍 [ProfileEntreprise] Vérification des champs directs:');
                        console.log('  - prenom:', this.data.prenom);
                        console.log('  - nom:', this.data.nom);
                        console.log('  - email:', this.data.email);
                        // Initialiser si vides
                        this.data.prenom = this.data.prenom || '';
                        this.data.nom = this.data.nom || '';
                        this.data.email = this.data.email || '';
                    }
                    
                    console.log('🔍 [ProfileEntreprise] Valeurs finales - prenom:', this.data.prenom, 'nom:', this.data.nom, 'email:', this.data.email);

                    // Build full URL for existing logo
                    this.logoPreview = this.data.logo
                        ? `${this.file_url}${this.data.logo}`
                        : null;
                   // console.log(this.data.logo);
                    // Ensure at least one address
                    if (!this.data.adresses || this.data.adresses.length === 0) {
                        this.data.adresses = [{
                            id: 0,
                            pays: '',
                            region: '',
                            code_postal: '',
                            adresse: '',
                            station_id: this.data.station_id || this.data.id || 0
                        }];
                    } else {
                        // S'assurer que toutes les adresses ont station_id
                        this.data.adresses = this.data.adresses.map((adr: any) => ({
                            ...adr,
                            station_id: adr.station_id || this.data.station_id || this.data.id || 0
                        }));
                    }
                    console.log('🔍 [ProfileEntreprise] Adresses récupérées:', this.data.adresses);

                    // Ensure at least one telephone
                    if (!this.data.telephones || this.data.telephones.length === 0) {
                        this.data.telephones = [{
                            id: 0,
                            numero: '',
                            type: '',
                            station_id: this.data.station_id || this.data.id || 0
                        }];
                    } else {
                        // S'assurer que tous les téléphones ont station_id
                        this.data.telephones = this.data.telephones.map((tel: any) => ({
                            ...tel,
                            station_id: tel.station_id || this.data.station_id || this.data.id || 0,
                            numero: tel.numero ? String(tel.numero) : '',
                            type: tel.type || ''
                        }));
                    }
                    console.log('🔍 [ProfileEntreprise] Téléphones récupérés:', this.data.telephones);
                }
            },
            error: (err) => {
              //  console.error(err);
                this.toastr.error('Erreur de chargement de la station');
            }
        });

    }
    selectedLogoFile: File | null = null;
    onFileSelected(event: Event) {
        const file = (event.target as HTMLInputElement).files?.[0];
        this.dataError.logo = '';
        this.selectedLogoFile = null;
        if (file) {
            if (file.size > 1024 * 1024) {
                this.dataError.logo = 'Le fichier ne doit pas dépasser 1 Mo.';
                return;
            }
            this.selectedLogoFile = file;
            const reader = new FileReader();
            reader.onload = () => {
                this.logoPreview = reader.result as string; // preview before upload
            };
            reader.readAsDataURL(file);

            // upload to server
          /*  const formData = new FormData();
            formData.append('file', file);
            this.stationService.uploadFile(formData).subscribe({
                next: (res: any) => {
                    if (res?.path) {

                        this.data.logo = `${this.file_url}${res.path}`;
                    } else {
                        this.dataError.logo = 'Réponse du serveur invalide (champ "path" manquant).';
                    }
                },
                error: () => {
                  //  this.dataError.logo = 'Erreur lors du téléversement du fichier.';
                }
            });*/
        }
    }


    addTel(): void {
        if (this.data.telephones.length < 5) {
            const newTel: Telephone = {
                id: 0,
                numero: '',
                type: '',
                station_id: this.data.station_id
            };
            this.data.telephones.push(newTel);
        } else {
            this.toasterInfo("Vous ne pouvez pas ajouter plus de 5 numéros de téléphone.");
        }
    }

    deleteTel(index: number): void {
        if (this.data.telephones.length > 1) {
            this.data.telephones.splice(index, 1);
        }
    }

    addAdress(): void {
        if (this.data.adresses.length < 5) {
            this.data.adresses.push({
                id: 0,
                pays: '',
                region: '',
                code_postal: '',
                adresse: '',
                station_id: this.data.station_id
            });
        } else {
            this.toasterInfo("Vous ne pouvez pas ajouter plus de 5 adresses.");
        }
    }

    deleteAdress(index: number): void {
        if (this.data.adresses.length > 1) {
            this.data.adresses.splice(index, 1);
        }
    }


    toasterInfo(msg: string): void {
        this.toastr.info(msg, '', {
            positionClass: 'toast-top-right',
            toastClass: 'toast ngx-toastr',
            closeButton: true
        });
    }


    submit(): void {
        this.dataError = {
            label: '',
            nom_entreprise: '',
            logo: '',
            adresses: this.data.adresses.map(() => ({region: '', code_postal: '', adresse: ''})),
            telephones: this.data.telephones.map(() => ''),
            telephoneTypes: this.data.telephones.map(() => ''), // New array initialized
        };

        let hasError = false;

        if (!this.data.nom_entreprise || !this.data.nom_entreprise.trim()) {
            this.dataError.nom_entreprise = "Le nom de l'entreprise est obligatoire";
            hasError = true;
        }

        this.data.adresses.forEach((adresse, index) => {
            // Only check required fields for the first address (as per original logic structure)
            if (index === 0) {
                if (!adresse.region || !adresse.region.trim()) {
                    this.dataError.adresses[index].region = "Région requise";
                    hasError = true;
                }
                if (!adresse.code_postal || !adresse.code_postal.trim()) {
                    this.dataError.adresses[index].code_postal = "Code postal requis";
                    hasError = true;
                }
                if (!adresse.adresse || !adresse.adresse.trim()) {
                    this.dataError.adresses[index].adresse = "Adresse requise";
                    hasError = true;
                }
            }
        });


        this.dataError.telephones = [];
        this.data.telephones.forEach((tel, i) => {
            this.dataError.telephones[i] = '';
            // Convertir en string si c'est un nombre, puis vérifier
            const numeroStr = tel.numero ? String(tel.numero).trim() : '';
            if (!numeroStr) {
                this.dataError.telephones[i] = 'Numéro requis';
                hasError = true;
            }
        });

        // ✅ Extra check: ensure logo has been uploaded
        if (!this.data.logo && !this.selectedLogoFile) {
            this.dataError.logo = 'Le logo est obligatoire.';
            hasError = true;
        }

        if (hasError) {
            this.toastr.error('Veuillez corriger les erreurs dans le formulaire.', 'Attention', {
                positionClass: 'toast-top-right',
              //  toastClass: 'toast ngx-toastr custom-error-toast',
            });
            return;
        }

        // Upload du logo si un fichier a été sélectionné
        if (this.selectedLogoFile) {
            const formData = new FormData();
            formData.append('file', this.selectedLogoFile);
            this.stationService.uploadFile(formData).subscribe({
                next: (res: any) => {
                    if (res?.path) {
                        this.data.logo = res.path; // Stocker seulement le chemin relatif
                        this.updateStationData();
                    } else {
                        this.dataError.logo = 'Réponse du serveur invalide (champ "path" manquant).';
                        this.toastr.error('Erreur lors du téléversement du logo.', '', {
                            positionClass: 'toast-top-right',
                        });
                    }
                },
                error: () => {
                    this.dataError.logo = 'Erreur lors du téléversement du fichier.';
                    this.toastr.error('Erreur lors du téléversement du logo.', '', {
                        positionClass: 'toast-top-right',
                    });
                }
            });
        } else {
            // Pas de nouveau logo, mettre à jour directement
            this.updateStationData();
        }
    }

    private updateStationData(): void {
        // Préparer le logo : si c'est une URL complète, extraire seulement le chemin relatif
        let logoPath = this.data.logo || '';
        if (logoPath && logoPath.includes(this.file_url)) {
            logoPath = logoPath.replace(this.file_url, '');
        }

        // Préparer les données pour la mise à jour
        const stationData: any = {
            id: this.data.id || 0,
            client_id: this.data.client_id || this.clientId || 0,
            station_id: this.data.station_id || this.stationId || 0,
            logo: logoPath,
            label: this.data.label || this.data.nom_entreprise || '',
            nom_entreprise: this.data.nom_entreprise || this.data.label || '',
            matricule_fiscale: this.data.matricule_fiscale || '',
            site_web: this.data.site_web || '',
            adresses: this.data.adresses.map((adr: any) => ({
                id: adr.id || 0,
                pays: adr.pays || '',
                region: adr.region || '',
                code_postal: adr.code_postal || '',
                adresse: adr.adresse || '',
                station_id: adr.station_id || this.data.station_id || this.data.id || 0
            })),
            telephones: this.data.telephones.map((tel: any) => {
                const telData = {
                    id: tel.id || 0,
                    numero: tel.numero ? String(tel.numero).trim() : '',
                    type: tel.type ? String(tel.type).trim() : '',
                    station_id: tel.station_id || this.data.station_id || this.data.id || 0
                };
                console.log('📤 [ProfileEntreprise] Téléphone mappé:', telData);
                return telData;
            })
        };

        // Préparer les téléphones pour les coordonnées
        const telephonesToSend = this.data.telephones
            .filter((tel: any) => tel.numero && String(tel.numero).trim() && tel.type && String(tel.type).trim())
            .map((tel: any) => ({
                id: tel.id || 0,
                numero: tel.numero ? String(tel.numero).trim() : '',
                type: tel.type ? String(tel.type).trim() : '',
                station_id: tel.station_id || this.data.station_id || this.data.id || 0
            }));

        console.log('📤 [ProfileEntreprise] Téléphones filtrés à envoyer:', telephonesToSend);
        console.log('📤 [ProfileEntreprise] Nombre de téléphones valides:', telephonesToSend.length);

        // Ajouter les coordonnées (prenom, nom, email) avec les téléphones associés
        // Vérifier si coordonnees existe déjà dans les données
        let coordonneeId = 0;
        if (this.data.coordonnees && Array.isArray(this.data.coordonnees) && this.data.coordonnees.length > 0) {
            coordonneeId = this.data.coordonnees[0].id || 0;
        } else if (this.data.coordonnees && !Array.isArray(this.data.coordonnees)) {
            coordonneeId = this.data.coordonnees.id || 0;
        }

        if (this.data.prenom || this.data.nom || this.data.email || telephonesToSend.length > 0) {
            stationData.coordonnees = [{
                id: coordonneeId,
                prenom: this.data.prenom || '',
                nom: this.data.nom || '',
                email: this.data.email || '',
                station_id: this.data.station_id || this.stationId || 0,
                telephones: telephonesToSend
            }];
        }

        // Garder aussi les téléphones au niveau de la station pour compatibilité
        stationData.telephones = telephonesToSend;

        console.log('📤 [ProfileEntreprise] Données à envoyer dans PUT:', stationData);
        console.log('📤 [ProfileEntreprise] Coordonnées:', stationData.coordonnees);
        console.log('📤 [ProfileEntreprise] Téléphones à envoyer:', stationData.telephones);
        console.log('📤 [ProfileEntreprise] Adresses à envoyer:', stationData.adresses);
        console.log('📤 [ProfileEntreprise] Valeurs - prenom:', this.data.prenom, 'nom:', this.data.nom, 'email:', this.data.email);

        const stationIdToUpdate = this.data.id || this.data.station_id || this.stationId || 0;

        // Mettre à jour la station avec PUT
        this.stationService.updateStation(stationIdToUpdate, stationData).subscribe({
            next: (res) => {
                console.log('✅ [ProfileEntreprise] Réponse PUT:', res);
                this.toastr.success('Modification enregistrée avec succès !', '', {
                    positionClass: 'toast-top-right',
                    toastClass: 'toast ngx-toastr custom-success-toast',
                });
                // Recharger les données après la mise à jour
                if (res.station) {
                    this.data = res.station;
                    
                    // Récupérer les coordonnées après la mise à jour
                    let telephonesFromCoordonnees: any[] = [];
                    if (this.data.coordonnees && Array.isArray(this.data.coordonnees) && this.data.coordonnees.length > 0) {
                        const coordonnee = this.data.coordonnees[0];
                        this.data.prenom = coordonnee.prenom || '';
                        this.data.nom = coordonnee.nom || '';
                        this.data.email = coordonnee.email || '';
                        // Récupérer les téléphones depuis coordonnees
                        if (coordonnee.telephones && Array.isArray(coordonnee.telephones) && coordonnee.telephones.length > 0) {
                            telephonesFromCoordonnees = coordonnee.telephones;
                            console.log('✅ [ProfileEntreprise] Téléphones récupérés depuis coordonnées après PUT:', telephonesFromCoordonnees);
                        }
                    } else if (this.data.coordonnees && !Array.isArray(this.data.coordonnees)) {
                        this.data.prenom = this.data.coordonnees.prenom || '';
                        this.data.nom = this.data.coordonnees.nom || '';
                        this.data.email = this.data.coordonnees.email || '';
                        if (this.data.coordonnees.telephones && Array.isArray(this.data.coordonnees.telephones)) {
                            telephonesFromCoordonnees = this.data.coordonnees.telephones;
                        }
                    }
                    
                    // Utiliser les téléphones de coordonnees ou ceux de la station
                    if (telephonesFromCoordonnees.length > 0) {
                        this.data.telephones = telephonesFromCoordonnees.map((tel: any) => ({
                            ...tel,
                            station_id: tel.station_id || this.data.station_id || this.data.id || 0,
                            numero: tel.numero ? String(tel.numero) : '',
                            type: tel.type || ''
                        }));
                    } else if (!this.data.telephones || this.data.telephones.length === 0) {
                        this.data.telephones = [{
                            id: 0,
                            numero: '',
                            type: '',
                            station_id: this.data.station_id || this.data.id || 0
                        }];
                    } else {
                        this.data.telephones = this.data.telephones.map((tel: any) => ({
                            ...tel,
                            station_id: tel.station_id || this.data.station_id || this.data.id || 0,
                            numero: tel.numero ? String(tel.numero) : '',
                            type: tel.type || ''
                        }));
                    }
                    console.log('✅ [ProfileEntreprise] Téléphones finaux après rechargement:', this.data.telephones);
                    
                    // S'assurer que les adresses sont correctement initialisées
                    if (!this.data.adresses || this.data.adresses.length === 0) {
                        this.data.adresses = [{
                            id: 0,
                            pays: '',
                            region: '',
                            code_postal: '',
                            adresse: '',
                            station_id: this.data.station_id || this.data.id || 0
                        }];
                    } else {
                        this.data.adresses = this.data.adresses.map((adr: any) => ({
                            ...adr,
                            station_id: adr.station_id || this.data.station_id || this.data.id || 0
                        }));
                    }
                    
                    console.log('✅ [ProfileEntreprise] Données rechargées après PUT:', this.data);
                    console.log('✅ [ProfileEntreprise] Téléphones rechargés:', this.data.telephones);
                    
                    this.logoPreview = this.data.logo
                        ? `${this.file_url}${this.data.logo}`
                        : null;
                }
            },
            error: (err) => {
                this.toastr.error('Échec de l’enregistrement', '', {
                    positionClass: 'toast-top-right',
                    toastClass: 'toast ngx-toastr custom-error-toast',
                });
                console.error('Erreur mise à jour station:', err);
            }
        });
    }
    clearFieldError(fieldName: string): void {
        if (this.dataError[fieldName]) {
            this.dataError[fieldName] = '';
        }
    }
    clearAddressFieldError(index: number, field: 'region' | 'code_postal' | 'adresse') {
        this.dataError.adresses[index][field] = '';
    }

    onPhoneInput(event: any, index: number) {
        const input = event.target;
        const value = input.value;

        // Clear previous error
        this.clearPhoneError(index);

        // Validate phone number
        this.validatePhoneNumber(value, index);
    }

    validatePhoneNumber(phoneNumber: string, index: number) {
        // Remove any non-digit characters
        const cleanNumber = phoneNumber.replace(/\D/g, '');

        // Check if empty
        if (!cleanNumber) {
            this.dataError.telephones[index] = 'Le numéro de téléphone est requis';
            return false;
        }

        // Check if exactly 8 digits
        if (cleanNumber.length !== 8) {
            this.dataError.telephones[index] = 'Le numéro doit contenir exactement 8 chiffres';
            return false;
        }

        // Check if starts with valid Tunisian prefix (optional)
        const validPrefixes = ['2', '4', '5', '7', '9'];
        if (!validPrefixes.includes(cleanNumber.charAt(0))) {
            this.dataError.telephones[index] = 'Numéro de téléphone invalide';
            return false;
        }

        // Clear error if valid
        this.dataError.telephones[index] = '';
        return true;
    }

    clearPhoneError(index: number) {
        if (this.dataError.telephones[index]) {
            this.dataError.telephones[index] = '';
        }
    }

// Alternative: Use reactive forms for better validation
    validatePhoneOnSubmit() {
        this.data.telephones.forEach((tel, index) => {
            if (!tel.numero) {
                this.dataError.telephones[index] = 'Le numéro de téléphone est requis';
            } else if (tel.numero.toString().length !== 8) {
                this.dataError.telephones[index] = 'Le numéro doit contenir exactement 8 chiffres';
            } else if (tel.numero < 0) {
                this.dataError.telephones[index] = 'Le numéro ne peut pas être négatif';
            } else {
                this.dataError.telephones[index] = '';
            }
        });
    }

}
